import { useState } from 'react';
import { useLanguage } from '../i18n';
import { useInterview } from './InterviewContext';
import { Lightbulb, SkipForward, RefreshCw, CheckCircle, XCircle } from 'lucide-react';

export default function InterviewControls() {
  const { t } = useLanguage();
  const i = t.interview;
  const { clarifying, regenerating, clarify, redo, endSession } = useInterview();
  const [clarificationOpen, setClarificationOpen] = useState(false);

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        onClick={async () => {
          setClarificationOpen(true);
          await clarify();
        }}
        disabled={clarifying}
        className="min-h-[44px] px-3 py-1.5 text-sm font-medium text-slate hover:bg-mist border border-cloud flex items-center gap-1.5 transition-colors disabled:opacity-50"
      >
        <Lightbulb size={14} /> {clarifying ? '...' : i.clarify}
      </button>
      <button
        type="button"
        onClick={() => {
          if (confirm(i.redoConfirm)) {
            void redo();
          }
        }}
        disabled={regenerating}
        className="min-h-[44px] px-3 py-1.5 text-sm font-medium text-slate hover:bg-mist border border-cloud flex items-center gap-1.5 transition-colors disabled:opacity-50"
      >
        <RefreshCw size={14} className={regenerating ? 'animate-spin' : ''} /> {regenerating ? i.redoRunning : i.redo}
      </button>
      <button
        type="button"
        onClick={() => {
          if (confirm(i.sessionAbandonConfirm)) {
            void endSession('abandoned');
          }
        }}
        className="min-h-[44px] px-3 py-1.5 text-sm font-medium text-ash hover:bg-mist border border-cloud flex items-center gap-1.5 transition-colors"
      >
        <XCircle size={14} /> {i.sessionAbandon}
      </button>
      <button
        type="button"
        onClick={() => {
          if (confirm(i.sessionEndConfirm)) {
            void endSession('complete');
          }
        }}
        className="min-h-[44px] px-3 py-1.5 text-sm font-medium bg-emerald-600 hover:bg-emerald-700 text-white flex items-center gap-1.5 transition-colors"
      >
        <CheckCircle size={14} /> {i.sessionEnd}
      </button>
      {clarificationOpen && (
        <button
          type="button"
          onClick={() => setClarificationOpen(false)}
          className="min-h-[44px] px-3 py-1.5 text-sm font-medium text-ash hover:bg-mist border border-cloud flex items-center gap-1.5 transition-colors"
        >
          <SkipForward size={14} /> {i.clarifyClose}
        </button>
      )}
    </div>
  );
}
